<script>
import AnimationFullRewardEarned from "./animation-full-reward-earned";
import AnimationFullAccomplishment from "./animation-full-accomplishment";

export default {
  name: "AnimationParsingFunctions",
  mixins: [AnimationFullAccomplishment, AnimationFullRewardEarned],

  computed: {
    currentLeague: function () {
      return this.$store.getters["user/getUserLeagueInfos"];
    },
    bufferedAnimationEventCount() {
      return this.$store.state.popups.pendingAnimationEvents.length;
    },
    animationBufferOwnerReady() {
      return this.animationBufferDrainOwner === true;
    },
    bufferedAnimationRunning() {
      return this.$store.getters["popups/getQueueAnimationIsRunning"];
    },
    bufferDrainable() {
      return (
        this.animationBufferOwnerReady &&
        !this.$store.state.popups.documentHidden &&
        this.bufferedAnimationEventCount > 0 &&
        !this.bufferedAnimationRunning
      );
    },
  },
  watch: {
    bufferDrainable: {
      handler(canDrain) {
        if (canDrain) this.drainBufferedAnimationEvents();
      },
      immediate: true,
    },
  },
  methods: {
    drainBufferedAnimationEvents() {
      if (!this.bufferDrainable) return;

      const evt = this.$store.state.popups.pendingAnimationEvents[0];
      this.$store.commit("popups/shiftPendingAnimationEvent");
      try {
        this.dispatchBufferedAnimation(evt);
      } catch (e) {
        console.error("[animation] drain threw for event", evt && evt.type, e);
        this.$store.commit("popups/setQueueAnimationIsRunning", false);
      }

      this.$nextTick(() => {
        if (this.bufferDrainable) {
          this.drainBufferedAnimationEvents();
        }
      });
    },
    dispatchBufferedAnimation(evt) {
      if (!evt || !evt.type) return;
      console.log("[animation] dispatch", evt.type, evt.payload);
      const p = evt.payload;
      switch (evt.type) {
        case "levelup":
          return this.mapApiJsonUserLevelUp(p);
        case "achievement-updated": {
          if (!p) return;
          this.AnimationFullAccomplishmentAnimate(["achieve", p]);
          const newLvl = p.level;
          const rewards =
            p.achievement &&
            p.achievement.level_rewards &&
            p.achievement.level_rewards[newLvl];
          if (rewards && rewards.gold) {
            this.AnimationFullRewardEarnedAnimate(
              [{ reward: "gold", amount: this.formatNumber(rewards.gold) }],
              false
            );
          }
          return;
        }
        case "loyalty-updated":
          return this.AnimationFullAccomplishmentAnimate(["loyalty", p]);
        case "jackpot-won":
          return this.AnimationKingWin(p);
        case "league-reward":
          return this.mapApiJsonUserLeague(p);
        case "kronenpass-end":
          return this.mapApiJsonKronenpassLevelUp(p);
        case "seasonpass-end":
          return this.mapApiJsonSeasonPassLevelUp(p);
        case "kronenpass-tier":
          return this.mapApiJsonKronenpassTierRewards(p);
        case "seasonpass-tier":
          return this.mapApiJsonSeasonPassTierRewards(p);
        case "kingspath-completed": {
          if (!p) return;
          const callback = () => {
            this.$router.push("/kingspath");
          };
          return this.AnimationFullAccomplishmentAnimate(
            ["kingspath", p.level + 1],
            callback
          );
        }
      }
    },
    mapUserLeagueChange: function (data) {
      //get current league
      let current_league = this.currentLeague;
      if (!current_league || !current_league.league) {
        return;
      }

      let reason = data.action;

      //update store
      let newObj = current_league;
      newObj.league = data.newLeague;
      this.$store.commit("user/setUserLeagueInfos", newObj);

      //show animation
      const league_title = data.newLeague.title;
      this.AnimationFullAccomplishmentAnimate(["adel-" + reason, league_title]);
    },

    mapApiJsonCardRedeem: function (data) {
      let result = [];

      if (data.reward.type === "gold") {
        result.push({
          reward: "gold",
          amount: this.formatNumber(data.reward.amount),
        });
      }

      this.AnimationFullRewardEarnedAnimate(result, false);
    },
    mapApiJsonCardUpgrade: function (amount) {
      let result = [];
      result.push({ reward: "elixir", amount: this.formatNumber(amount) });

      this.AnimationFullRewardEarnedAnimate(result, false);
    },

    mapApiJsonChest: function (data) {
      let result = [];

      if (data.gold) {
        result.push({ reward: "gold", amount: this.formatNumber(data.gold) });
      }

      let cards = data.cards;
      if (cards) {
        cards.forEach((card) => {
          let amount = card.amount;
          result.push({
            reward: "card",
            cardId: card.usercard.card.id,
            amount: amount,
          });
        });
      }

      this.AnimationFullRewardEarnedAnimate(result, false);
    },

    mapApiJsonDailyLogin(data) {
      let result = [];

      let amount_gold = 0,
        amount_crown = 0,
        cards = [];

      //get rewards
      for (let props in data) {
        data[props].forEach((el) => {
          switch (el.type) {
            case "gold":
              amount_gold += el.amount;
              break;
            case "crown":
              amount_crown += el.amount;
              break;
            case null:
              el.booked.forEach((card) => {
                cards.push(card);
              });
              break;
          }
        });
      }

      //insert collected rewards in correct format
      if (amount_gold > 0) {
        result.push({
          reward: "gold",
          amount: this.formatNumber(amount_gold),
        });
      }
      if (amount_crown > 0) {
        result.push({
          reward: "crown",
          amount: this.formatNumber(amount_crown),
        });
      }
      for (let i = 0; i < cards.length; i++) {
        result.push({
          reward: "card",
          cardId: cards[i].card.id,
          amount: cards[i].amount,
        });
      }

      this.AnimationFullRewardEarnedAnimate(result, false, false, true);
    },

    mapApiJsonTreasury(data) {
      let result = [];

      let amount_gold = 0,
        amount_crown = 0,
        amount_loyalty = 0,
        amount_elixir = 0,
        cards = [];

      //get rewards
      data.forEach((el) => {
        switch (el.asset.title) {
          case "gold":
            amount_gold += el.amount;
            break;
          case "crowns":
            amount_crown += el.amount;
            break;
          case "loyalty":
            amount_loyalty += el.amount;
            break;
          case "elixir":
            amount_elixir += el.amount;
            break;
          default:
            let card = el.asset;
            let amount = el.amount;
            card.amount = amount;
            cards.push(card);
        }
      });

      //insert collected rewards in correct format
      if (amount_gold > 0) {
        result.push({
          reward: "gold",
          amount: this.formatNumber(amount_gold),
        });
      }
      if (amount_crown > 0) {
        result.push({
          reward: "crown",
          amount: this.formatNumber(amount_crown),
        });
      }
      if (amount_loyalty > 0) {
        result.push({
          reward: "loyalty",
          amount: this.formatNumber(amount_loyalty),
        });
      }
      if (amount_elixir > 0) {
        result.push({
          reward: "elixir",
          amount: this.formatNumber(amount_elixir),
        });
      }

      for (let i = 0; i < cards.length; i++) {
        result.push({
          reward: "card",
          cardId: cards[i].id,
          amount: cards[i].amount,
        });
      }

      this.AnimationFullRewardEarnedAnimate(result, false);
    },

    mapTermsRewards(data) {
      let result = [];

      let amount_gold = 0,
        amount_crown = 0,
        amount_elixir = 0;

      //get rewards
      data.forEach((el) => {
        console.log("el", el);
        if (el.type && el.type === "gold") {
          amount_gold += el.amount;
        } else if (el.type && el.type === "crown") {
          amount_crown += el.amount;
        } else if (!el.type && el.asset.endsWith("Elixir")) {
          amount_elixir += el.amount;
        } else if (el.type && el.type.endsWith("Card")) {
          result.push({
            reward: "card",
            cardId: el.id,
            amount: el.amount,
          });
        }
      });

      //insert collected rewards in correct format
      if (amount_gold > 0) {
        result.push({
          reward: "gold",
          amount: this.formatNumber(amount_gold),
        });
      }
      if (amount_crown > 0) {
        result.push({
          reward: "crown",
          amount: this.formatNumber(amount_crown),
        });
      }

      if (amount_elixir > 0) {
        result.push({
          reward: "elixir",
          amount: this.formatNumber(amount_elixir),
        });
      }

      this.AnimationFullRewardEarnedAnimate(result);
    },

    mapApiJsonBonusSlot(data) {
      let result = [];

      //insert collected rewards in correct format
      if (data.gold > 0) {
        result.push({
          reward: "gold",
          amount: this.formatNumber(data.gold),
        });
      }
      if (data.crowns > 0) {
        result.push({
          reward: "crown",
          amount: this.formatNumber(data.crowns),
        });
      }

      if (data.expbooster > 0) {
        result.push({
          reward: "expbooster",
          amount: data.expbooster,
        });
      }

      for (let i = 0; i < data.cards.length; i++) {
        const cards = data.cards[i];
        for (let j = 0; j < cards.length; j++) {
          result.push({
            reward: "card",
            cardId: cards[j].card.id,
            amount: cards[j].handle_amount,
          });
        }
      }

      if (result.length > 0) {
        this.AnimationFullRewardEarnedAnimate(result, false);
      }
    },

    mapApiJsonUserLeague(data) {
      let rewards = data.rewards;
      let amount = data.amount;
      let result = [];

      rewards.forEach((reward) => {
        let type = reward.reward.asset;

        if (type === "App\\Models\\Asset\\Card") {
          for (let i = 0; i < reward.asset.length; i++) {
            result.push({
              reward: "card",
              cardId: reward.asset[i].card.id,
              amount: reward.asset[i].amount,
            });
          }
        }

        let amount = reward.reward.amount;

        if (type === "App\\Models\\Asset\\Currency" && amount > 500) {
          result.push({
            reward: "gold",
            amount: this.formatNumber(amount),
          });
        }
        if (type === "App\\Models\\Asset\\Currency" && amount <= 500) {
          result.push({
            reward: "crown",
            amount: this.formatNumber(amount),
          });
        }
        if (type === "App\\Models\\Asset\\Point") {
          result.push({
            reward: "loyalty",
            amount: this.formatNumber(amount),
          });
        }
      });

      let callback = () => {
        this.AnimationFullRewardEarnedAnimate(result);
      };
      this.AnimationFullAccomplishmentAnimate(
        ["adel-reward", amount],
        callback
      );
    },

    mapApiJsonFriendReward(data) {
      let result = [];

      const rewards = data.rewards;
      if (rewards.gold > 0) {
        result.push({
          reward: "gold",
          amount: this.formatNumber(rewards.gold),
        });
      }

      if (rewards.crowns > 0) {
        result.push({
          reward: "crown",
          amount: this.formatNumber(rewards.crowns),
        });
      }

      this.AnimationFullRewardEarnedAnimate(result);
    },
    mapApiJsonKingspathComplete(data) {
      let result = [];
      let cards = [];

      data.forEach((el) => {
        if (el.card) {
          let card = el.card;
          card.amount = el.amount;
          cards.push(card);
        }

        if (el.overtakeBonus) {
          result.push({
            reward: "gold",
            amount: this.formatNumber(el.overtakeBonus.amount),
          });
        }
      });

      for (let i = 0; i < cards.length; i++) {
        result.push({
          reward: "card",
          cardId: cards[i].id,
          amount: cards[i].amount,
        });
      }

      this.AnimationFullRewardEarnedAnimate(result, false);
      this.$store.commit("kingspath/setKingspathRewardsCompleted", null);
    },

    mapApiJsonUserLevelUp(data) {
      const newLevel = data.newLevel;
      const rewards = data.rewards;

      let result = [];
      let cardAmount = 0;

      rewards.forEach((el) => {
        if (el.type === "CARD") {
          for (let i = 0; i < el.amount; i++) {
            cardAmount++;
          }
        } else {
          if (el.amount) {
            result.push({
              reward: el.type.toLowerCase(),
              amount: this.formatNumber(el.amount),
            });
          } else {
            result.push({
              reward: el.type.toLowerCase(),
            });
          }
        }
      });

      if (cardAmount > 0) {
        result.push({
          reward: "card",
          amount: cardAmount,
        });
      }

      this.AnimationFullAccomplishmentAnimate(["levelup", newLevel, result]);
    },

    mapApiJsonKronenpassLevelUp(data) {
      const rewards = (data && data.rewards) || [];
      const level =
        (data && data.user && data.user.level && data.user.level.level) || 0;
      let ticketAmount = level + 1;
      let result = [];

      rewards.forEach((reward) => {
        //expbooster seconds to minutes
        if (reward[0].asset.title === "expbooster") {
          reward[0].amount /= 60;
        }

        result.push({
          reward: reward[0].asset.title,
          amount: this.formatNumber(reward[0].amount),
        });
      });

      if (result.length > 1) {
        ticketAmount *= 2;
      }

      result.push({
        reward: "ticket",
        amount: this.formatNumber(ticketAmount),
      });

      this.AnimationFullAccomplishmentAnimate([
        "kronenpassLevelUp",
        level,
        result,
      ]);
    },
    mapApiJsonSeasonPassLevelUp(data) {
      const rewards = Array.isArray(data.rewards) ? data.rewards : [];
      const result = [];

      rewards.forEach((reward) => {
        const asset = reward.asset || {};
        const payload = asset.payload || {};
        const rewardType = this.normalizeSeasonPassRewardType(
          payload.type || asset.wallet || asset.title || asset.type
        );
        let amount = reward.amount;

        if (rewardType === "expbooster") {
          amount /= 60;
        }

        result.push({
          reward: rewardType,
          amount: this.formatNumber(amount),
        });
      });

      const pass = (data && data.pass) || this.getSeasonPassForAnimation(data);
      const badgeUrl = this.extractSeasonPassBadgeUrl(pass);
      const passName = this.extractSeasonPassName(pass);

      const completedLevelId = data && data.user && data.user.level_id;
      const passLevels = (pass && pass.levels) || [];
      const completedTier = passLevels.find(
        (l) => l && l.id === completedLevelId
      );
      const level =
        (completedTier && Number(completedTier.level)) ||
        (data && data.user && data.user.level && data.user.level.level) ||
        0;

      this.AnimationFullAccomplishmentAnimate([
        "seasonPassLevelUp",
        level,
        result,
        badgeUrl,
        passName,
      ]);
    },
    extractSeasonPassName(pass) {
      if (!pass) return "";
      const cfg = this.parseSeasonPassDisplayConfig(
        pass.display_config || pass.displayConfig
      );
      const text = cfg && cfg.text;
      const locale = (this.$store && this.$store.state.locale) || "de";
      if (text && typeof text === "object") {
        return text[locale] || text.fallback || text.en || pass.title || "";
      }
      return pass.title || "";
    },
    getSeasonPassForAnimation(data) {
      const passId =
        data && data.user && data.user.season_pass_id
          ? data.user.season_pass_id
          : null;
      const activePasses =
        (this.$store &&
          this.$store.state &&
          this.$store.state.seasonPass &&
          this.$store.state.seasonPass.activeSeasonPasses) ||
        [];

      if (passId) {
        const pass = activePasses.find((item) => item.id === passId);
        if (pass) return pass;
      }

      return (
        (this.$store &&
          this.$store.getters &&
          this.$store.getters["seasonPass/getCurrentSeasonPass"]) ||
        activePasses[0] ||
        null
      );
    },
    extractSeasonPassBadgeUrl(pass) {
      if (!pass) return "";
      const cfg = this.parseSeasonPassDisplayConfig(
        pass.display_config || pass.displayConfig
      );

      return (
        this.getSeasonPassMediaUrl(pass, "badge") ||
        this.getSeasonPassMediaCollectionUrl(pass, ["badge"]) ||
        this.getSeasonPassConfigUrl(cfg, "badge") ||
        this.getSeasonPassConfigUrl(cfg, "badgeImage") ||
        this.getSeasonPassConfigUrl(cfg, "badge_image") ||
        this.getSeasonPassConfigUrl(cfg, "sidebar") ||
        this.getSeasonPassMediaUrl(pass, "progress_badge") ||
        this.getSeasonPassMediaCollectionUrl(pass, [
          "progress_badge",
          "progressBadge",
        ]) ||
        this.getSeasonPassConfigUrl(cfg, "progressBadge") ||
        this.getSeasonPassConfigUrl(cfg, "progress_badge") ||
        ""
      );
    },
    parseSeasonPassDisplayConfig(raw) {
      if (!raw) return {};
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }
      return raw;
    },
    getSeasonPassMediaUrl(source, key) {
      const media = source && source[key];
      if (Array.isArray(media)) return (media[0] && media[0].url) || "";
      if (media && typeof media === "object") return media.url || "";
      return typeof media === "string" ? media : "";
    },
    getSeasonPassMediaCollectionUrl(source, keys) {
      if (!Array.isArray(source && source.media)) return "";

      const match = source.media.find((item) =>
        keys.includes(
          item.collection_name ||
            item.collectionName ||
            item.name ||
            item.key ||
            item.type
        )
      );

      return match ? match.url || match.original_url || "" : "";
    },
    getSeasonPassConfigUrl(cfg, key) {
      return (
        cfg[key] ||
        cfg[`${key}Url`] ||
        cfg[`${key}_url`] ||
        cfg[`${key}Path`] ||
        cfg[`${key}_path`] ||
        cfg[`${key}PathFull`] ||
        cfg[`${key}_path_full`] ||
        ""
      );
    },
    normalizeSeasonPassRewardType(type) {
      const normalized = type ? String(type).toLowerCase() : "";

      if (normalized.endsWith("card") || normalized === "cards") {
        return "card";
      }
      if (normalized === "crowns") {
        return "crown";
      }
      if (normalized === "loyaltypoint" || normalized === "loyaltypoints") {
        return "loyalty";
      }
      if (normalized === "booster" || normalized === "exp_booster") {
        return "expbooster";
      }

      return normalized || "gold";
    },

    mapApiJsonKronenpassTierRewards(data) {
      const rewards = data.rewards;
      let ticketAmount = 0;

      let rewardCollection = [];

      let result = [];

      //gather all rewards
      rewards.forEach((reward) => {
        //expbooster seconds to minutes
        if (reward[0].asset.title === "expbooster") {
          reward[0].amount /= 60;
        }
        if (!rewardCollection[reward[0].asset.title]) {
          rewardCollection[reward[0].asset.title] = 0;
        }
        rewardCollection[reward[0].asset.title] += reward[0].amount;
      });

      // push to result array
      for (let key in rewardCollection) {
        result.push({
          reward: key,
          amount: this.formatNumber(rewardCollection[key]),
        });
      }

      // tickets
      for (let i = 0; i <= data.user.level.level; i++) {
        ticketAmount += i;
      }
      result.push({
        reward: "ticket",
        amount: this.formatNumber(ticketAmount),
      });

      this.AnimationFullAccomplishmentAnimate([
        "kronenpassTierRewards",
        ticketAmount,
        result,
      ]);
    },

    mapApiJsonSeasonPassTierRewards(data) {
      const rawRewards = Array.isArray(data && data.rewards)
        ? data.rewards
        : [];
      if (!rawRewards.length) return;

      const rewardCollection = {};
      rawRewards.forEach((entry) => {
        let reward = entry;
        if (Array.isArray(entry)) {
          reward = entry[0];
        } else if (entry && typeof entry === "object" && entry["0"]) {
          reward = entry["0"];
        }
        if (!reward) return;
        const asset = reward.asset || {};
        const payload = asset.payload || {};
        const rewardType = this.normalizeSeasonPassRewardType(
          payload.type || asset.wallet || asset.title || asset.type
        );
        let amount = Number(reward.amount) || 0;
        if (rewardType === "expbooster") {
          amount /= 60;
        }
        if (!rewardCollection[rewardType]) {
          rewardCollection[rewardType] = 0;
        }
        rewardCollection[rewardType] += amount;
      });

      const result = Object.keys(rewardCollection).map((key) => ({
        reward: key,
        amount: this.formatNumber(rewardCollection[key]),
      }));

      const userLevel =
        (data && data.user && data.user.level && data.user.level.level) || 0;

      const pass = (data && data.pass) || this.getSeasonPassForAnimation(data);
      const badgeUrl = this.extractSeasonPassBadgeUrl(pass);

      this.AnimationFullAccomplishmentAnimate([
        "seasonPassTierRewards",
        userLevel,
        result,
        badgeUrl,
      ]);
    },
  },
};
</script>

<style lang="scss"></style>
